import { render, staticRenderFns } from "./ItomBridgeDialog.vue?vue&type=template&id=2b4a5ef8&"
import script from "./ItomBridgeDialog.vue?vue&type=script&lang=js&"
export * from "./ItomBridgeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports